import styled from 'styled-components'

import { FemiBottomArea, FemiTitle } from '../../styles'

export const StyledFemiTechnicalIssues = {
  Title: styled(FemiTitle)`
    margin-bottom: 24px;
  `,
  Content: styled.div`
    padding-bottom: 144px;
  `,
  BottomArea: styled(FemiBottomArea)`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 8px;
  `,
}
